import React from "react";
import { IconButton, Paper, Slide } from "@material-ui/core";
import { Close } from '@material-ui/icons'
import { withStyles } from "@material-ui/core/styles";

import styles from "./RightDetailsPanelStyles";
import useGlobalContext from "../hooks/useGlobalContext";

export const Panel = props => {
  const { classes, children } = props;
  const {
    state: { openRightDetailsPanel },
    setOpenRightDetailsPanel
  } = useGlobalContext()

  return (
    <Slide direction='left' in={openRightDetailsPanel} mountOnEnter unmountOnExit>
      <Paper className={classes.panel} elevation={3}>
        <IconButton
          className={classes.closeButton}
          onClick={() => setOpenRightDetailsPanel(false)}
          size='medium'>
          <Close />
        </IconButton>
        {children}
      </Paper>
    </Slide>
  );
};

export default withStyles(styles)(Panel);
